document.addEventListener('DOMContentLoaded', function() {
  var slides = document.querySelectorAll('.slideshow-slide');

  slides.forEach(function(slide) {
    slide.style.cursor = 'pointer'; // Optional: changes cursor on hover
    
    slide.addEventListener('click', function() {    
      let url = slide.querySelector('a').href;
      
      if (url) {
        window.location.href = url;
      }
    });
  });

});

window.onload = function() {
  document.querySelectorAll('select.product-options-select option:disabled').forEach(function(option) {
    option.text += " - Out of Stock";
  });
};

document.addEventListener("DOMContentLoaded", function() {
  // Find the checkout button and add a click event listener
  var checkoutButton = document.querySelector('button.button-primary.checkout-button--disabled#checkout-button');
  if (checkoutButton) {
    checkoutButton.addEventListener('click', function(e) {
      // Get the 'agree' checkbox
      var agreeCheckbox = document.getElementById('agree');
      // Check if the checkbox is not required or if it is checked
      if (!agreeCheckbox.required || agreeCheckbox.checked) {
        // Submit the form here. Assuming the button is within a form.
        // You may need to specifically select and submit the form, as shown below.
        // This example assumes the button is inside the form you want to submit.
        this.form.submit();
      } else {
        // Prevent the form submission and show an alert
        e.preventDefault();
        alert("Your cart contains age restricted items. You must confirm that you are over 18 years old.");
      }
    });
  }

  // Handle changes to the 'agree' checkbox
  var agreeCheckbox = document.getElementById('agree');
  if (agreeCheckbox) {
    agreeCheckbox.addEventListener('change', function() {
      console.log('here 1');
      var cartAgeVerifier = document.getElementById('cart-age-verifier');
      var checkoutButton = document.querySelector('button#checkout-button');
      var additionalButtonsC = document.getElementById('additional-buttons-c');

      if (this.checked) {
        // Enable styling and elements for verified
        if (cartAgeVerifier) {
          cartAgeVerifier.classList.add('cart-age-verifier--enabled');
        }
        if (checkoutButton) {
          checkoutButton.classList.add('checkout-button--enabled');
        }
        if (additionalButtonsC) {
          additionalButtonsC.classList.remove('div-disabled');
        }
      } else {
        // Disable styling and elements for unverified
        if (checkoutButton) {
          checkoutButton.classList.remove('checkout-button--enabled');
        }
        if (additionalButtonsC) {
          additionalButtonsC.classList.add('div-disabled');
        }
      }
    });
  }
});



document.addEventListener('focusin', (e) => {

  let _privacy = document.querySelector('#shop-hcaptcha-badge-container a.privacy');
  let _terms = document.querySelector('#shop-hcaptcha-badge-container a.terms');
  let _badgeContainer = document.querySelector('#shop-hcaptcha-badge-container');

  if (_badgeContainer) {

    if (e.target == _privacy || e.target == _terms) {
  
      if (_badgeContainer.classList.contains('active')) {} else {
  
        console.log('does not has class');
        _badgeContainer.classList.add('active');
  
      }
  
    } else {
  
      if (_badgeContainer.classList.contains('active')) {
  
        _badgeContainer.classList.remove('active');
  
      } else {}
  
    }

  }

});


